var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2h16v16H2V2z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.636 4.337a4.274 4.274 0 014.286 4.293 4.274 4.274 0 01-4.286 4.293A4.275 4.275 0 014.344 8.63a4.275 4.275 0 014.292-4.293zm0-2.337C4.986 2 2 4.98 2 8.63s2.986 6.637 6.636 6.637c1.404 0 2.703-.45 3.775-1.196l3.588 3.582a1.164 1.164 0 001.659 0 1.168 1.168 0 000-1.653l-3.588-3.588a6.574 6.574 0 001.196-3.782c0-3.65-2.986-6.63-6.63-6.63z",
    fill: "currentColor"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzE1MzdfMTMzNjUiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjIiIHk9IjIiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMiAySDE4VjE4SDJWMloiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8xNTM3XzEzMzY1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC42MzYzOCA0LjMzNjg0QzExLjAxNDYgNC4zMzY4NCAxMi45MjIzIDYuMjQ1MTQgMTIuOTIyMyA4LjYzMDE2QzEyLjkyMjMgMTEuMDE1MiAxMS4wMTQ2IDEyLjkyMzUgOC42MzYzOCAxMi45MjM1QzYuMjUxNDQgMTIuOTIzNSA0LjM0MzUyIDExLjAxNTIgNC4zNDM1MiA4LjYzMDE2QzQuMzQzMzQgNi4yNDUxNCA2LjI1MTI1IDQuMzM2ODQgOC42MzYzOCA0LjMzNjg0Wk04LjYzNjM4IDJDNC45ODY0MiAyIDIgNC45Nzk4MSAyIDguNjMwMTZDMiAxMi4yODA1IDQuOTg2NDIgMTUuMjY3MyA4LjYzNjM4IDE1LjI2NzNDMTAuMDM5NyAxNS4yNjczIDExLjMzOTQgMTQuODE3OSAxMi40MTA4IDE0LjA3MTFMMTUuOTk4NSAxNy42NTI1QzE2LjQ1NDkgMTguMTE1OCAxNy4yMDEzIDE4LjExNTggMTcuNjU3NyAxNy42NTI1QzE4LjExNDEgMTcuMTk2MiAxOC4xMTQxIDE2LjQ1NjcgMTcuNjU3NyAxNi4wMDAyTDE0LjA3IDEyLjQxMTlDMTQuODIzNSAxMS4zMzM1IDE1LjI2NiAxMC4wMzM4IDE1LjI2NiA4LjYzMDM0QzE1LjI2NTggNC45OCAxMi4yNzk2IDIgOC42MzYzOCAyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjwvZz4KPC9zdmc+Cg==";
export { SvgSearch as ReactComponent };